import React from "react";
import { PartnerConfig } from "./partner_config";
import { TemplateOfferingListingGallery } from "../offering_v2/templates/template_offering_listing_gallery";
import { useOfferingsQuery } from "./api";
import { Template } from "../data/partner_offering";

interface TemplateCatalogGalleryProps {
  partnerConfig: PartnerConfig;
  partnerId: string;
  partnerName?: string;
  locationAdress?: string;
}

export const TemplateCatalogGallery = (props: TemplateCatalogGalleryProps) => {
  const { partnerConfig, partnerId, partnerName, locationAdress } = props;
  const offerings = useOfferingsQuery(partnerId);

  const meetingRoomOffering = offerings.find(
    (offering) =>
      offering.template === Template.MeetingRoomV2 ||
      offering.template === Template.MeetingRoom
  );

  if (!meetingRoomOffering) {
    return (
      <div>
        This partner does not have an offering with a slug 'meeting-room'
      </div>
    );
  }

  return (
    <TemplateOfferingListingGallery
      partnerConfig={partnerConfig}
      partnerId={partnerId}
      offeringId={meetingRoomOffering?.slug}
      partnerName={partnerName}
      locationAdress={locationAdress}
    />
  );
};
